<template>
  <div class="info-box-details">
    <div class="info-box-details-caption">Number of users<br />interacting with app</div>
    <div class="info-box-details-table">
      <table class="table table-borderless">
        <tbody>
          <tr repeat.for="activeUsers of model">
            <td style="text-align: left;">${ activeUsers.dateRangeName }</td>
            <td style="text-align: right;">${ activeUsers.usersCount }</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
